import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import Button, { ButtonProps } from '@material-ui/core/Button'
import { makeStyles, Theme } from '@material-ui/core/styles'
import listingColors from 'bpm/pages/ProductsPage/ProductDetailsPage/listingColors'
import clsx from 'clsx'
import React from 'react'

const { defaultSecondary } = listingColors

const tableSettingButtonStyles = makeStyles((theme: Theme) => ({
    actionButton: {
        backgroundColor: '#13B5EA',
        height: 26,
        fontSize: pxToRem(13),
        color: theme.palette.common.white,
        fontWeight: 'unset',
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
            cursor: 'pointer',
        },
    },
    disabled: {
        backgroundColor: defaultSecondary,
        color: theme.palette.common.white,
        '&:hover': {
            cursor: 'default',
        },
    },
}))

const TableSettingsButton: React.FC<ButtonProps> = ({
    children,
    disabled,
    ...other
}) => {
    const classes = tableSettingButtonStyles()
    return (
        <Button
            variant="contained"
            disabled={disabled}
            className={clsx(classes.actionButton, 'table-settings-button', {
                disabled,
            })}
            {...other}
        >
            {children}
        </Button>
    )
}

export default TableSettingsButton
